<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<button mat-icon-button class="d-flex justify-content-center flex-wrap" (click)="onClick()">
  <mat-icon>{{ icon }}</mat-icon>
</button>
